import { useState, useEffect } from "react";
import { responsiveArray } from "antd/es/_util/responsiveObserver";
function useMergeLevelPropByScreen(levelProp, screen) {
  const [prop, setProp] = useState(
    typeof levelProp !== "object" && typeof levelProp !== "undefined" ? `${levelProp}` : ""
  );
  const calcMergeLevel = () => {
    if (typeof levelProp === "string" || typeof levelProp === "number") {
      setProp(`${levelProp}`);
    }
    if (typeof levelProp !== "object") {
      return;
    }
    let newPropState;
    let isMissingLevel = false;
    for (let i = 0; i < responsiveArray.length; i++) {
      const breakpoint = responsiveArray[i];
      const curVal = levelProp[breakpoint];
      if (typeof curVal !== "undefined") {
        newPropState = `${curVal}`;
      }
      if (screen[breakpoint] && typeof newPropState === "undefined") {
        isMissingLevel = true;
        continue;
      }
      if (typeof newPropState !== "undefined" && (screen[breakpoint] || isMissingLevel)) {
        setProp(newPropState);
        return;
      }
    }
  };
  useEffect(() => {
    calcMergeLevel();
  }, [JSON.stringify(levelProp), screen]);
  return prop;
}
export {
  useMergeLevelPropByScreen as default
};
//# sourceMappingURL=useMergeLevelPropByScreen.js.map
